/*** IMPORTS FROM imports-loader ***/


/**
 * An even better animation frame.
 *
 * @copyright Oleg Slobodskoi 2015
 * @website https://github.com/kof/animationFrame
 * @license MIT
 */

module.exports = require('./lib/animation-frame')




//////////////////
// WEBPACK FOOTER
// ../~/animation-frame/index.js
// module id = 147
// module chunks = 3